const { REACT_APP_INNOVARISK_API } = process.env
const APIBASE = `${REACT_APP_INNOVARISK_API}/api`

export const APIRoutes = {
  auth: {
    getToken: `${APIBASE}/Auth/GetToken`,
    login: `${APIBASE}/Auth/Login`,
    resetPassword: `${APIBASE}/Auth/ResetPassword`,
    changePassword: `${APIBASE}/Auth/ChangePassword`,
    register: `${APIBASE}/Auth/Register`,
    changeUserInformation: `${APIBASE}/Auth/ChangeUserInformation`,
    resetPasswordSendEmailGenerateToken: `${APIBASE}/Auth/ResetPasswordSendEmailGenerateToken`,
    getUserInviteList: `${APIBASE}/Auth/GetUserInviteList`,
    generateInvite: `${APIBASE}/Auth/GenerateInvite`,
    deleteInvite: `${APIBASE}/Auth/DeleteInvite`,
  },
  broker: {
    getBroker: `${APIBASE}/Broker/GetBroker`,
    getBrokerContact: `${APIBASE}/Broker/GetBrokerContact`,
    getBrokerContacts: `${APIBASE}/Broker/GetBrokerContacts`,
    changeBrokerContactAccessLevel: `${APIBASE}/Broker/ChangeBrokerContactAccessLevel`,
    disableBrokerContact: `${APIBASE}/Broker/DisableBrokerContact`,
    enableBrokerContact: `${APIBASE}/Broker/EnableBrokerContact`,
    getBrokerStatementList: `${APIBASE}/Broker/GetBrokerStatementList`,
    getBrokerStatement: `${APIBASE}/Broker/GetBrokerStatement`,
    getBrokerList: `${APIBASE}/Broker/GetBrokerList`,
    saveBrokerReq: `${APIBASE}/Broker/SaveBrokerReq`,
    getBrokerReqList: `${APIBASE}/Broker/GetBrokerReqList`,
    addBrokerReqFiles: `${APIBASE}/Broker/AddBrokerReqFiles`,
    deleteBrokerReq: `${APIBASE}/Broker/DeleteBrokerReq`,
  },
  campaign: {
    getCampaignList: `${APIBASE}/Campaign/GetCampaignList`,
    getCampaign: `${APIBASE}/Campaign/GetCampaign`,
    saveCampaign: `${APIBASE}/Campaign/SaveCampaign`,
    deleteCampaign: `${APIBASE}/Campaign/DeleteCampaign`,
    addCampaignFiles: `${APIBASE}/Campaign/AddCampaignFiles`,
    removeCampaignFile: `${APIBASE}/Campaign/RemoveCampaignFile`,
  },
  claim: {
    getClaimList: `${APIBASE}/Claim/GetClaimList`,
  },
  doc: {
    getInnovariskDocs: `${APIBASE}/Doc/GetInnovariskDocs`,
    getSimDocs: `${APIBASE}/Doc/GetSimDocs`,
    getDocumentList: `${APIBASE}/Doc/GetDocumentList`,
    submitDocument: `${APIBASE}/Doc/SubmitDocument`,
    verifySignature: `${APIBASE}/Doc/VerifySignature`,
  },
  email: {
    sendEmail: `${APIBASE}/Email/SendEmail`,
    sendEmails: `${APIBASE}/Email/SendEmails`,
    sendProposalEmail: `${APIBASE}/Email/SendProposalEmail`,
  },
  file: {
    addFilesToAzure: `${APIBASE}/File/AddFilesToAzure`,
    getFilesFromAzure: `${APIBASE}/File/GetFilesFromAzure`,
    deleteFileFromAzure: `${APIBASE}/File/DeleteFileFromAzure`,
  },
  graph: {
    graph: `${APIBASE}/Graph`,
  },
  invoice: {
    getInvoiceList: `${APIBASE}/Invoice/GetInvoiceList`,
    getInvoice: `${APIBASE}/Invoice/GetInvoice`,
    getInvoiceDoc: `${APIBASE}/Invoice/GetInvoiceDoc`,
  },
  policy: {
    getPolicy: `${APIBASE}/Policy/GetPolicy`,
    getPoliciesList: `${APIBASE}/Policy/GetPolicyList`,
    getQuotationList: `${APIBASE}/Policy/GetQuotationList`,
    changePolicyAddress: `${APIBASE}/Policy/ChangePolicyAddress`,
  },
  page: {
    getPageList: `${APIBASE}/Page/GetPageList`,
    getPage: `${APIBASE}/Page/GetPage`,
    getPageBySlug: `${APIBASE}/Page/GetPageBySlug`,
    savePage: `${APIBASE}/Page/SavePage`,
    deletePage: `${APIBASE}/Page/DeletePage`,
    addPageFiles: `${APIBASE}/Page/AddPageFiles`,
    addPageQA: `${APIBASE}/Page/AddPageQA`,
    removePageFile: `${APIBASE}/Page/RemovePageFile`,
    removePageQA: `${APIBASE}/Page/RemovePageQA`,
  },
  portal: {
    getConfig: `${APIBASE}/Portal/GetConfig`,
    saveConfig: `${APIBASE}/Portal/SaveConfig`,
    getConfigList: `${APIBASE}/Portal/GetConfigList`,
    saveConfigList: `${APIBASE}/Portal/SaveConfigList`,
  },
  product: {
    getCategoryList: `${APIBASE}/Product/GetCategoryList`,
    createCategory: `${APIBASE}/Product/CreateCategory`,
    deleteCategory: `${APIBASE}/Product/DeleteCategory`,
    changeCategory: `${APIBASE}/Product/ChangeCategory`,
    getPortalProductList: `${APIBASE}/Product/GetPortalProductList`,
    deletePortalProduct: `${APIBASE}/Product/DeletePortalProduct`,
    getPortalProduct: `${APIBASE}/Product/GetPortalProduct`,
    savePortalProduct: `${APIBASE}/Product/SavePortalProduct`,
    getNewProducts: `${APIBASE}/Product/GetNewProducts`,
    addPortalProductFiles: `${APIBASE}/Product/AddPortalProductFiles`,
    removePortalProductFile: `${APIBASE}/Product/RemovePortalProductFile`,
  },
  sim: {
    getSimulation: `${APIBASE}/Sim/GetSimulation`,
    idCheck: `${APIBASE}/Sim/IdCheck`,
    getSimulationRating: `${APIBASE}/Sim/GetSimulationRating`,
    submitSimulation: `${APIBASE}/Sim/SubmitSimulation`,
    createNewBusiness: `${APIBASE}/Sim/CreateNewBusiness`,
    logSimulationInfo: `${APIBASE}/Sim/LogSimulationInfo`,
  },
  slider: {
    getSliderList: `${APIBASE}/Slider/GetSliderList`,
    saveSlider: `${APIBASE}/Slider/SaveSlider`,
    addSliderFiles: `${APIBASE}/Slider/AddSliderFiles`,
    removeSliderFile: `${APIBASE}/Slider/RemoveSliderFile`,
  },
  trainings: {
    getTrainingList: `${APIBASE}/Training/GetTrainingList`,
    getTraining: `${APIBASE}/Training/GetTraining`,
    saveTraining: `${APIBASE}/Training/SaveTraining`,
    deleteTraining: `${APIBASE}/Training/DeleteTraining`,
    addTrainingFiles: `${APIBASE}/Training/AddTrainingFiles`,
    removeTrainingFile: `${APIBASE}/Training/RemoveTrainingFile`,
    registerForTraining: `${APIBASE}/Training/RegisterForTraining`,
    generateCertificate: `${APIBASE}/Training/GenerateCertificate`,
  },
  webisodes: {
    getWebisodesList: `${APIBASE}/Webisodes/GetWebisodeList`,
    getWebisode: `${APIBASE}/Webisodes/GetWebisode`,
    saveWebisode: `${APIBASE}/Webisodes/SaveWebisode`,
    deleteWebisode: `${APIBASE}/Webisodes/DeleteWebisode`,
  },
}
